module.exports = __webpack_public_path__ + "img/paper_fail.b32f7109.svg";